import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

const About = () => (
  <section className=" flex flex-col justify-between items-center gap-4 pb-10 md:flex-row md:gap-8">
    <div className="m-auto md:mx-0" id="about">
      <StaticImage
        src="../../images/MyPicture.jpg"
        alt="Enrique's picture"
        loading="lazy"
        placeholder="blurred"
        layout="constrained"
        width={500}
        height={500}
        className="rounded-lg"
      />
    </div>
    <div className="flex flex-col gap-5">
      <h1 className="text-center md:text-left">
        <span className="hidden font-bold md:block md:text-4xl lg:text-6xl">
          Hello!
        </span>
        <span className="text-3xl font-bold md:text-4xl lg:text-5xl">
          I&apos;m Enrique Guerrero <br />
        </span>
        <span className="text-xl lg:text-3xl text-transparent bg-gradient-to-br from-pink-500  to-orange-400 bg-clip-text ">
          Frontend Developer
        </span>
      </h1>
      <div>
        <h2>About Me</h2>
        <p className="text-accentGray max-w-md text-sm lg:text-lg text-justify">
          I&apos;m a Civil Engineer that decided to change carrers after 2 years
          of working in the field. Currently i&apos;m studying Digital contents
          and Robotics and working at Applaudo Trainee program. I also love to
          play video games, art and programming.
        </p>
      </div>
    </div>
  </section>
);

export default About;
